import { Resource } from '../utils/resources';
import { ReactComponent as VirusIcon } from '../assets/virus.svg';
import { ReactComponent as BacteriaIcon } from '../assets/bacteria.svg';
import { ReactComponent as FumesIcon } from '../assets/fumes.svg';
import { ReactComponent as DustIcon } from '../assets/dust.svg';

type Type = 'virus' | 'bacteria' | 'fumes' | 'dust';
export type EnemyType = {
  type: Type;
  color: string;
  speed: number;
  points: number;
  size: number;
  resource: Resource;
  name: string;
  description: string;
  icon: typeof VirusIcon;
};

const computedStyles = getComputedStyle(document.documentElement);

export const enemies: EnemyType[] = [
  {
    type: 'virus',
    color: computedStyles.getPropertyValue('--virus-color'),
    speed: 160,
    points: 150,
    size: 50,
    resource: {
      url: 'virus',
      width: 193,
      height: 193,
    },
    icon: VirusIcon,
    name: 'Virus',
    description:
      'Små virus kan göra stor skada. Som tur är finns det luftfilter, luftrenare och munskydd som kan skydda oss!',
  },
  {
    type: 'bacteria',
    color: computedStyles.getPropertyValue('--bacteria-color'),
    speed: 120,
    points: 100,
    size: 100,
    resource: {
      url: 'bacteria',
      width: 173,
      height: 202,
    },
    icon: BacteriaIcon,
    name: 'Bakterier',
    description:
      'Bakterier i sig är inte något dåligt. Men skadliga bakterier ska man såklart akta sig för – förslagsvis med en luftrenare.',
  },
  {
    type: 'fumes',
    color: computedStyles.getPropertyValue('--fumes-color'),
    speed: 105,
    points: 50,
    size: 120,
    resource: {
      url: 'fumes',
      width: 183,
      height: 171,
    },
    icon: FumesIcon,
    name: 'Avgaser',
    description:
      'Det är svårt att värja sig mot avgaser, men med ett riktigt bra luftfilter kommer man långt.',
  },
  {
    type: 'dust',
    color: computedStyles.getPropertyValue('--dust-color'),
    speed: 90,
    points: 25,
    size: 140,
    resource: {
      url: 'dust',
      width: 156,
      height: 182,
    },
    icon: DustIcon,
    name: 'Damm & pollen',
    description:
      'Damm och pollen är svårt att se, men desto lättare att känna. Därför det är så bra att ha en luftrenare som kan eliminera det.',
  },
];
